import dispatcher from '../dispatcher/dispatcher.js';

export function getPaths(pathObj){
    dispatcher.dispatch({
        type: 'GET_PATHS',
        object: pathObj
    });
}
export function redrawPath(){
    dispatcher.dispatch({
        type: 'PATH_REDRAW',
    });
}
export function buildRelationship(obj){
    dispatcher.dispatch({
        type: "RELATIONSHIP_BUILDER",
        object: obj
    })
}
export function deleteRelationship(obj){
    dispatcher.dispatch({
        type: "DELETE_RELATIONSHIPS",
        object: obj
    })
}
export function setRelationships(obj){
    dispatcher.dispatch({
        type: "SET_RELATIONSHIPS",
        object: obj
    })
}


// WEBPACK FOOTER //
// ./src/action/pathAction.js